import type { Xinglet } from '@xing-com/crate-xinglet';

import { App } from './app';

export default class VideoPlayerXinglet implements Xinglet {
  public getComponent() {
    return () => <App />;
  }
}
